import Event from '../const/event';
import { log, logMethodCall } from './debug';
import { dynamicContentObserver } from './dynamicContentObserver';

export const autoAssignTagMatches = (tag, pathname, callback) => {
  if (tag.autoAssignPath) {
    let path = tag.autoAssignPath;
    if (path === '[EMPTY]') {
      path = '';
    }
    if (new RegExp(path).test(pathname)) {
      if (!tag.autoAssignFunction && !tag.autoAssignSelector) {
        return callback(true);
      }
      // wait for function check
    } else {
      return;
    }
  }

  if (tag.autoAssignFunction) {
    try {
      if (tag.autoAssignCheckInterval && !isNaN(tag.autoAssignCheckInterval)) {
        const interval = setInterval(() => {
          try {
            const matches = eval(tag.autoAssignFunction);

            if (typeof matches === 'object' && matches.then) {
              try {
                matches.then(() => {
                  clearInterval(interval);
                  callback(true);
                });
              } catch (err) {
              }
            } else if (matches) {
              clearInterval(interval);
              callback(true);
            }
          } catch (err) {
            log.debug(err);
          }
        }, tag.autoAssignCheckInterval);
        return null;
      }

      const matches = eval(tag.autoAssignFunction);
      if (typeof matches === 'object' && matches.then) {
        try {
          matches.then(() => {
            callback(true);
          });
        } catch (err) {
        }
        return;
      }
      return callback(!!matches);
    } catch (err) {
      log.debug(err);
    }
  }

  if (tag.autoAssignSelector) {
    try {
      dynamicContentObserver.watchForElements(tag.autoAssignSelector, () => {
        callback(true);
      }, {
        event: 'click',
        immediate: true,
        observerId: `tag-${tag._id}-${tag.autoAssignSelector}`
      });
      return null;
    } catch (err) {
      log.debug(err);
    }
  }

  return callback(false);
};

export const checkTags = (tags, storedTags, tagSubscription, waitForSubscription, pathname) => {
  logMethodCall('checkTags');

  if (tags && tags.length && typeof localStorage !== 'undefined') {
    tags.forEach((tag) => {
      try {
        autoAssignTagMatches(tag, pathname, (matches) => {
          if (matches) {
            const visitsNeeded = !isNaN(tag.autoAssignVisits) ? tag.autoAssignVisits : 0;
            const visitsStorageKey = `cleverpush-tag-autoAssignVisits-${tag._id}`;
            const visitsStorage = tag.autoAssignSessionVisits ? sessionStorage : localStorage;

            const dateKey = new Date().toISOString().substr(0, 10);
            let dateAfter;
            if (tag.autoAssignDays) {
              dateAfter = new Date();
              dateAfter.setDate(dateAfter.getDate() - tag.autoAssignDays);
            }

            const visitsStr = visitsStorage.getItem(visitsStorageKey);
            let visits = 0;
            let dailyVisits = {};
            if (tag.autoAssignDays) {
              try {
                dailyVisits = JSON.parse(visitsStr) || {};
                if (typeof dailyVisits !== 'object') {
                  dailyVisits = {};
                }
                Object.keys(dailyVisits || {}).forEach((curDateKey) => {
                  const curDate = new Date(curDateKey);
                  if (curDate >= dateAfter) {
                    visits += dailyVisits[curDateKey] || 0;
                  } else {
                    delete dailyVisits[curDateKey];
                  }
                });
              } catch (ignored) {
                dailyVisits = {};
              }
            } else if (typeof visitsStr === 'string' && !isNaN(visitsStr)) {
              visits = parseInt(visitsStr, 10);
            }

            const sessionsNeeded = !isNaN(tag.autoAssignSessions) ? tag.autoAssignSessions : 0;
            const sessionsStorageKey = `cleverpush-tag-autoAssignSessions-${tag._id}`;
            const sessionsCountedStorageKey = `cleverpush-tag-autoAssignSessionsCounted-${tag._id}`;
            const sessionsStr = localStorage.getItem(sessionsStorageKey);
            let sessions = 0;
            let dailySessions = {};
            if (tag.autoAssignDays) {
              try {
                dailySessions = JSON.parse(sessionsStr) || {};
                if (typeof dailySessions !== 'object') {
                  dailySessions = {};
                }
                Object.keys(dailySessions || {}).forEach((curDateKey) => {
                  const curDate = new Date(curDateKey);
                  if (curDate >= dateAfter) {
                    sessions += dailySessions[curDateKey] || 0;
                  } else {
                    delete dailySessions[curDateKey];
                  }
                });
              } catch (ignored) {
                dailySessions = {};
              }
            } else if (typeof sessionsStr === 'string' && !isNaN(sessionsStr)) {
              sessions = parseInt(sessionsStr, 10);
            }

            if (sessions >= sessionsNeeded) {
              if (visits >= visitsNeeded) {
                if (!isNaN(tag.autoAssignSeconds) && tag.autoAssignSeconds) {
                  setTimeout(() => {
                    tagSubscription(tag._id);
                  }, tag.autoAssignSeconds * 1000);
                } else {
                  tagSubscription(tag._id);
                }
              } else if (tag.autoAssignDays) {
                if (!dailyVisits[dateKey]) {
                  dailyVisits[dateKey] = 0;
                }
                dailyVisits[dateKey] += 1;

                waitForSubscription().then(() => {
                  localStorage.setItem(visitsStorageKey, JSON.stringify(dailyVisits));
                });
              } else {
                visits += 1;
                waitForSubscription().then(() => {
                  visitsStorage.setItem(visitsStorageKey, visits.toString());
                });
              }
            } else if (tag.autoAssignDays) {
              if (!dailyVisits[dateKey]) {
                dailyVisits[dateKey] = 0;
              }
              dailyVisits[dateKey] += 1;

              waitForSubscription().then(() => {
                localStorage.setItem(visitsStorageKey, JSON.stringify(dailyVisits));
              });

              if (sessionStorage.getItem(sessionsCountedStorageKey) !== 'true') {
                if (!dailySessions[dateKey]) {
                  dailySessions[dateKey] = 0;
                }
                dailySessions[dateKey] += 1;

                waitForSubscription().then(() => {
                  sessionStorage.setItem(sessionsCountedStorageKey, 'true');
                  localStorage.setItem(sessionsStorageKey, JSON.stringify(dailySessions));
                });
              }
            } else {
              visits += 1;
              waitForSubscription().then(() => {
                visitsStorage.setItem(visitsStorageKey, visits.toString());
              });

              if (sessionStorage.getItem(sessionsCountedStorageKey) !== 'true') {
                sessions += 1;

                waitForSubscription().then(() => {
                  sessionStorage.setItem(sessionsCountedStorageKey, 'true');
                  localStorage.setItem(sessionsStorageKey, sessions.toString());
                });
              }
            }
          }
        });
      } catch (error) {
        log.debug('checkTags', error?.message);
      }
    });
  }
};

export function initTags(context) {
  const init = () => {
    context.subscriptionManager.storageManager.getTags().then((storedTags) => {
      const tags = context.config.channelTags;
      checkTags(tags, storedTags, context.tagSubscription.bind(context), context.waitForSubscription.bind(context), location.pathname);
    });
  };

  if (
    !context.config.trackTagsOnlyWhenTopicEnabled
    || !context.config.trackTagsOnlyWhenTopicEnabledIds.length
  ) {
    init();
    return;
  }

  context.subscriptionManager.storageManager.getTopics().then((storedTopics) => {
    if (context.config.trackTagsOnlyWhenTopicEnabledIds.every((topicId) => storedTopics.includes(topicId))) {
      init();
      return;
    }

    // recursive check if we can now init the tags if topics have been changed
    context.once(Event.TOPICS_SET, () => initTags(context));
  });
}

export function tagSubscription(context, tagId, callbackParam) {
  logMethodCall('tagSubscription', tagId);

  const callback = typeof callbackParam === 'function' ? callbackParam : () => { };

  context.waitForInit().then(() => {
    context.waitForSubscription().then((subscriptionId) => {
      if (tagId) {
        context.subscriptionManager.storageManager.getTags().then((storedTags) => {
          const tagDate = context.subscriptionManager.storageManager.getTagDate(tagId);
          if (storedTags.indexOf(tagId) < 0 || !tagDate || tagDate.getTime() < (Date.now() - (1000 * 60 * 60 * 12))) {
            context.subscriptionManager.storageManager.setTags([...storedTags, tagId]);
            context.api.tagSubscription(subscriptionId, tagId).then((result) => {
              context.trigger(Event.TAGS_SET);
              callback(result);
            }).catch(callback);
          } else {
            log.debug('tag is already in stored tags');
          }
        });
      } else {
        log.error('tag id not specified');
      }
    });
  });
}

export function untagSubscription(context, tagId, callbackParam) {
  logMethodCall('untagSubscription', tagId);

  const callback = typeof callbackParam === 'function' ? callbackParam : () => { };

  context.waitForInit().then(() => {
    context.waitForSubscription().then((subscriptionId) => {
      if (tagId) {
        context.subscriptionManager.storageManager.getTags().then((storedTags) => {
          storedTags.splice(storedTags.indexOf(tagId), 1);
          context.subscriptionManager.storageManager.setTags(storedTags);
        });
        context.api.untagSubscription(subscriptionId, tagId).then((result) => {
          context.trigger(Event.TAGS_SET);
          callback(result);
        }).catch(callback);
      } else {
        log.error('tag id not specified');
      }
    });
  });
}

export function getTags(context, callback) {
  logMethodCall('getTags');
  if (typeof callback !== 'function') {
    log.error('Please provide a callback function (err, tags) => {} to getTags');
    return Promise.reject();
  }
  return context.waitForInit().then(() => {
    if (context.subscriptionManager) {
      context.subscriptionManager.storageManager.getTags().then((tags) => {
        callback(null, tags);
      });
    }
  });
}
